<template>
	<UiIcon
		:title="$t(title)"
		class="cms-html-editor-toolbar-item"
		:class="{ 'is-active': isActive ? isActive() : null }"
		:value="icon"
		@click="action"
	/>
</template>

<script>
import { UiIcon } from '@/modules/ui/components';
import useI18n from '@/modules/i18n/mixins/useI18n.js';

export default {
	components: { UiIcon },
	props: {
		icon: {
			type: String,
			required: true,
		},

		title: {
			type: String,
			required: true,
		},

		action: {
			type: Function,
			required: true,
		},

		isActive: {
			type: Function,
			default: null,
		},
	},
	mixins: [useI18n],
	i18n: {
    en: {
      'HtmlEditorToolbar.Heading1': 'Heading 1',
      'HtmlEditorToolbar.Heading2': 'Heading 2',
      'HtmlEditorToolbar.Heading3': 'Heading 3',
      'HtmlEditorToolbar.Heading4': 'Heading 4',
      'HtmlEditorToolbar.Heading5': 'Heading 5',
      'HtmlEditorToolbar.Paragraph': 'Paragraph',
      'HtmlEditorToolbar.AlignLeft': 'Align left',
      'HtmlEditorToolbar.AlignCenter': 'Align center',
      'HtmlEditorToolbar.AlignRight': 'Align right',
      'HtmlEditorToolbar.Justify': 'Justify',
      'HtmlEditorToolbar.TextColor': 'Text color',
      'HtmlEditorToolbar.BackgroundColor': 'Background color',
      'HtmlEditorToolbar.Bold': 'Bold',
      'HtmlEditorToolbar.Italic': 'Italic',
      'HtmlEditorToolbar.Highlight': 'Highlight',
      'HtmlEditorToolbar.Underline': 'Underline',
      'HtmlEditorToolbar.BulletList': 'Bullet list',
      'HtmlEditorToolbar.NumberedList': 'Numbered list',
      'HtmlEditorToolbar.CodeBlock': 'Code block',
      'HtmlEditorToolbar.InsertEditLink': 'Insert/edit link',
      'HtmlEditorToolbar.InsertEditImage': 'Insert/edit image',
      'HtmlEditorToolbar.InsertTemplate': 'Insert template',
      'HtmlEditorToolbar.SubBlock': 'Sub block',
      'HtmlEditorToolbar.InsertHorizontalLine': 'Insert horizontal line',
      'HtmlEditorToolbar.SkipLine': 'Skip line',
      'HtmlEditorToolbar.CleanFormatting': 'Clean formatting',
      'HtmlEditorToolbar.Undo': 'Undo',
      'HtmlEditorToolbar.Redo': 'Redo',
      'HtmlEditorToolbar.Preview': 'Preview',
      'HtmlEditorToolbar.sourceCode': 'Source code',
      'HtmlEditorToolbar.Clear': 'Clear'

    },

    es: {
      'HtmlEditorToolbar.Heading1': 'Encabezado 1',
      'HtmlEditorToolbar.Heading2': 'Encabezado 2',
      'HtmlEditorToolbar.Heading3': 'Encabezado 3',
      'HtmlEditorToolbar.Heading4': 'Encabezado 4',
      'HtmlEditorToolbar.Heading5': 'Encabezado 5',
      'HtmlEditorToolbar.Paragraph': 'Párrafo',
      'HtmlEditorToolbar.AlignLeft': 'Alinear a la izquierda',
      'HtmlEditorToolbar.AlignCenter': 'Alinear al centro',
      'HtmlEditorToolbar.AlignRight': 'Alinear a la derecha',
      'HtmlEditorToolbar.Justify': 'Justificar',
      'HtmlEditorToolbar.TextColor': 'Color del texto',
      'HtmlEditorToolbar.BackgroundColor': 'Color de fondo',
      'HtmlEditorToolbar.Bold': 'Negrita',
      'HtmlEditorToolbar.Italic': 'Cursiva',
      'HtmlEditorToolbar.Highlight': 'Rayar',
      'HtmlEditorToolbar.Underline': 'Subrayado',
      'HtmlEditorToolbar.BulletList': 'Lista de viñetas',
      'HtmlEditorToolbar.NumberedList': 'Lista numerada',
      'HtmlEditorToolbar.CodeBlock': 'Bloque de código',
      'HtmlEditorToolbar.InsertEditLink': 'Insertar/editar enlace',
      'HtmlEditorToolbar.InsertEditImage': 'Insertar/editar imagen',
      'HtmlEditorToolbar.InsertTemplate': 'Insertar plantilla',
      'HtmlEditorToolbar.SubBlock': 'Subbloque',
      'HtmlEditorToolbar.InsertHorizontalLine': 'Insertar linea horizontal',
      'HtmlEditorToolbar.SkipLine': 'Saltar de linea',
      'HtmlEditorToolbar.CleanFormatting': 'Limpiar formato',
      'HtmlEditorToolbar.Undo': 'Deshacer',
      'HtmlEditorToolbar.Redo': 'Rehacer',
      'HtmlEditorToolbar.Preview': 'Previsualizar',
      'HtmlEditorToolbar.sourceCode': 'Código fuente',
      'HtmlEditorToolbar.Clear': 'Limpiar'
    },

    de: {
      'HtmlEditorToolbar.Heading1': 'Überschrift 1',
      'HtmlEditorToolbar.Heading2': 'Überschrift 2',
      'HtmlEditorToolbar.Heading3': 'Überschrift 3',
      'HtmlEditorToolbar.Heading4': 'Überschrift 4',
      'HtmlEditorToolbar.Heading5': 'Überschrift 5',
      'HtmlEditorToolbar.Paragraph': 'Absatz',
      'HtmlEditorToolbar.AlignLeft': 'Links ausrichten',
      'HtmlEditorToolbar.AlignCenter': 'Zentriert ausrichten',
      'HtmlEditorToolbar.AlignRight': 'Rechtsbündig',
      'HtmlEditorToolbar.Justify': 'Ausrichten',
      'HtmlEditorToolbar.TextColor': 'Textfarbe',
      'HtmlEditorToolbar.BackgroundColor': 'Hintergrundfarbe',
      'HtmlEditorToolbar.Bold': 'Fettdruck',
      'HtmlEditorToolbar.Italic': 'Kursiv',
      'HtmlEditorToolbar.Highlight': 'Hervorheben',
      'HtmlEditorToolbar.Underline': 'Unterstreichen',
      'HtmlEditorToolbar.BulletList': 'Aufgelistete Liste',
      'HtmlEditorToolbar.NumberedList': 'Nummerierte Liste',
      'HtmlEditorToolbar.CodeBlock': 'Code-Block',
      'HtmlEditorToolbar.InsertEditLink': 'Link einfügen/bearbeiten',
      'HtmlEditorToolbar.InsertEditImage': 'Bild einfügen/bearbeiten',
      'HtmlEditorToolbar.InsertTemplate': 'Vorlage einfügen',
      'HtmlEditorToolbar.SubBlock': 'Unterblock',
      'HtmlEditorToolbar.InsertHorizontalLine': 'Horizontale Linie einfügen',
      'HtmlEditorToolbar.SkipLine': 'Zeile überspringen',
      'HtmlEditorToolbar.CleanFormatting': 'Formatierung löschen',
      'HtmlEditorToolbar.Undo': 'Rückgängig machen',
      'HtmlEditorToolbar.Redo': 'Wiederholen',
      'HtmlEditorToolbar.Preview': 'Vorschau',
      'HtmlEditorToolbar.sourceCode': 'Quellcode',
      'HtmlEditorToolbar.Clear': 'Löschen'
    },
  },
}
</script>

<style lang="scss">
.cms-html-editor-toolbar-item {
	border: none;
	width: 1.75rem;
	cursor: pointer;
	height: 1.75rem;
	padding: 0.25rem;
	margin-right: 0.25rem;
	border-radius: 0.4rem;
  background: transparent;

	&.is-active, &:hover {
		color: white;
		background-color: #303030;
	}
}
</style>